import { ApolloClient, ApolloLink, InMemoryCache, Observable, createHttpLink } from '@apollo/client';
import { detect } from 'detect-browser';

const timeoutLink = new ApolloLink((operation, forward) => {
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
  if (controller) {
    const ctx = operation.getContext();
    operation.setContext({ fetchOptions: { ...ctx.fetchOptions, controller, signal: controller.signal } });
  }
  return new Observable((observer) => {
    const sub = forward(operation).subscribe(
      (result) => { clearTimeout(timer); observer.next(result); observer.complete(); },
      (err) => { clearTimeout(timer); observer.error(err); observer.complete(); }
    );
    const timer = setTimeout(() => {
      controller?.abort();
      observer.error(new Error('Request timed out'));
      sub.unsubscribe();
    }, 60000);
    return () => { clearTimeout(timer); sub.unsubscribe(); };
  });
});

const browser = detect();

const link = createHttpLink({
  uri: '/graphql',
  headers: {
    device: browser ? `${browser.name}/${browser.version}, ${browser.os}` : 'webapp'
  }
});

export const client = new ApolloClient({
  devtools: {
    enabled: true
  },
  link: timeoutLink.concat(link),
  cache: new InMemoryCache({ addTypename: false }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'ignore'
    },
    query: {
      // fetchPolicy: 'cache-first',
      errorPolicy: 'all'
    }
  }
});
